export default __webpack_public_path__ + "static/media/cog.0a1cfc6f.svg";